import { useEffect, useCallback } from 'react';

interface UsePreventUnloadOptions {
  /**
   * Whether the prevention should be active
   */
  shouldPrevent: boolean;
}

/**
 * Hook to prevent accidental window/tab closing when there are unsaved changes
 * @param options Configuration options for the prevention behavior
 */
export const usePreventUnload = ({
  shouldPrevent,
}: UsePreventUnloadOptions) => {
  const handleBeforeUnload = useCallback(
    (event: BeforeUnloadEvent) => {
      if (shouldPrevent) {
        event.preventDefault();
        event.returnValue = '';
      }
    },
    [shouldPrevent]
  );

  useEffect(() => {
    if (shouldPrevent) {
      window.addEventListener('beforeunload', handleBeforeUnload);

      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }
  }, [shouldPrevent, handleBeforeUnload]);
};
